import { useUpdateDefaultSearchFilterMutation } from '@entities/search'

interface UpdateDefaultSearchFilterManagerHookProps {
  updateDefaultSearchFilterPayload: {
    selectedSearchFilterId: number | undefined
    selectedSearchFilterTitle: string | undefined
    searchAssistantId: string | number | undefined
    entityObjectCode: string | undefined
  }
}

export const useUpdateDefaultSearchFilterManager = (
  props: UpdateDefaultSearchFilterManagerHookProps
) => {
  const { updateDefaultSearchFilterPayload } = props

  const [updateDefaultSearchFilter, { isLoading: isSettingDefaultSearchFilter }] =
    useUpdateDefaultSearchFilterMutation()

  const handleUpdateDefaultSearchFilter = () => {
    updateDefaultSearchFilter({
      id: updateDefaultSearchFilterPayload.selectedSearchFilterId,
      title: updateDefaultSearchFilterPayload.selectedSearchFilterTitle,
      searchAssistantId: updateDefaultSearchFilterPayload.searchAssistantId,
      objectCode: updateDefaultSearchFilterPayload.entityObjectCode,
    })
  }

  return { handleUpdateDefaultSearchFilter, isSettingDefaultSearchFilter }
}
